export const ACCESS_TOKEN_NAME = 'accessToken'
export const GITLAB_TOKEN_NAME = 'gitlabToken'